// eslint-disable-next-line no-restricted-imports
import {
  Configuration,
  DefaultApi as WatchlistApi,
  DefaultApiDeleteWatchlistGroupRequest as WatchlistApiDeleteWatchlistGroupRequest,
  DefaultApiGetWatchlistDefaultGroupRequest as WatchlistApiGetWatchlistDefaultGroupRequest,
  DefaultApiPostWatchlistGroupRequest as WatchlistApiPostWatchlistGroupRequest,
  DefaultApiPutWatchlistGroupOrderRequest as WatchlistApiPutWatchlistGroupOrderRequest,
  DefaultApiPutWatchlistGroupRequest as WatchlistApiPutWatchlistGroupRequest,
} from '@eih-netbroker/api-watchlist';
import { AxiosInstance } from 'axios';
import { IConfigAPI } from '../config';
import { ResourceHeadersWithToken } from '../services/useResource';
import { BaseResource } from './base.resource';

type CreateWatchListGroupRequest = Omit<
  WatchlistApiPostWatchlistGroupRequest,
  keyof ResourceHeadersWithToken | 'userId'
>;

type DeleteWatchListGroupRequest = Omit<
  WatchlistApiDeleteWatchlistGroupRequest,
  keyof ResourceHeadersWithToken | 'userId'
>;

type UpdateWatchListGroupRequest = Omit<
  WatchlistApiPutWatchlistGroupRequest,
  keyof ResourceHeadersWithToken | 'userId'
>;

type GetWatchlistDefaultGroupRequest = Omit<
  WatchlistApiGetWatchlistDefaultGroupRequest,
  keyof ResourceHeadersWithToken
>;

type GroupOrderRequest = Omit<WatchlistApiPutWatchlistGroupOrderRequest, keyof ResourceHeadersWithToken | 'userId'>;

export class WatchlistResource extends BaseResource {
  // Name has to be overridden, since the build job renames it to 'r' and
  // every resource class will have the same name
  // @ts-ignore
  static readonly name = 'WatchlistResource';

  private watchListApi: WatchlistApi;

  constructor(axiosInstance: AxiosInstance, basePath: string, configApi: IConfigAPI) {
    super(axiosInstance, `${basePath}${configApi.usUrl.watchList}`, configApi);
    this.watchListApi = new WatchlistApi(
      new Configuration({
        basePath: `${basePath}${configApi.usUrl.watchList}`,
      }),
      `${basePath}${configApi.usUrl.watchList}`,
      axiosInstance,
    );
  }

  getWatchlist = (headers: ResourceHeadersWithToken) => {
    return this.watchListApi.getWatchlist({ userId: headers.userid, ...headers });
  };

  createWatchListGroup = (request: CreateWatchListGroupRequest, headers: ResourceHeadersWithToken) => {
    return this.watchListApi.postWatchlistGroup({ ...request, ...headers, userId: headers.userid });
  };

  updateWatchListGroup = (request: UpdateWatchListGroupRequest, headers: ResourceHeadersWithToken) => {
    return this.watchListApi.putWatchlistGroup({ ...request, ...headers, userId: headers.userid });
  };

  updateWatchListGroupOrder = (request: GroupOrderRequest, headers: ResourceHeadersWithToken) => {
    return this.watchListApi.putWatchlistGroupOrder({ ...request, ...headers, userId: headers.userid });
  };

  deleteWatchListGroup = (request: DeleteWatchListGroupRequest, headers: ResourceHeadersWithToken) => {
    return this.watchListApi.deleteWatchlistGroup({ ...request, ...headers, userId: headers.userid });
  };

  getWatchlistDefaults = (headers: ResourceHeadersWithToken) => {
    return this.watchListApi.getWatchlistDefaults({ ...headers });
  };

  getWatchlistDefaultGroup = (request: GetWatchlistDefaultGroupRequest, headers: ResourceHeadersWithToken) => {
    return this.watchListApi.getWatchlistDefaultGroup({ ...request, ...headers });
  };

  getVersion() {
    return this.watchListApi.getVersion();
  }
}
